import { Box, Flex, Input } from '@chakra-ui/react';
import { useField } from 'formik';
import { useSelector } from 'react-redux';
import { selectUser } from '@/store/bootstrap/selectors';
import { useState } from 'react';
import dayjs from 'dayjs';
import { DayPicker } from 'react-day-picker';
import PopoverWrapper from '@/ui/popover/popoverwrapper';
import { useDateFormat } from '@/hooks';
import { KInput } from '@/ui-library/components/atoms/KInput';

// Dev Note
// This component is in some other places apart from Filters
export const FilterDatePicker = ({ item, field, formik }) => {
  const {
    name,
    isCustomize,
    containerRef,
    inputStyles = {},
    customOnChange = () => {},
    isSetFormattedDate = false,
    skipDateSetting = false,
    customDisableDateValue = null,
    dayPickerProps = {},
    inputProps = {},
    styleVersion = 'v1',
    hasFieldValue = false,
  } = item;
  const [, meta, helpers] = useField(name);
  const { setValue, setTouched, setError } = helpers;
  const { value } = field || {};
  const { error, touched } = meta;
  const currUser = useSelector(selectUser);
  const { date_fmt } = currUser || {};
  const [date, setDate] = useState('');
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const { dateFormat } = useDateFormat();

  const formatDate = (date, date_fmt) => {
    if (!date) return '';
    const format = dateFormat ? dateFormat.label : date_fmt || 'MM/DD/YYYY';
    return dayjs(date).isValid() ? dayjs(date).format(format) : '';
  };
  const convertDateFormatForDatePicker = (dateStr) => {
    if (!dateStr) return '';
    const [day, month, year] = dateStr?.includes('/')
      ? dateStr.split('/')
      : dateStr.includes('-')
      ? dateStr.split('-')
      : dateStr.split(' ');
    return `${month}/${day}/${year}`;
  };

  const setFieldProps = (date) => {
    if (!date) return; // Prevent clearing on undefined date

    const formattedDate = formatDate(date, date_fmt);
    if (!skipDateSetting) setDate(formattedDate);

    const setValueDate = dayjs(date).isValid()
      ? dayjs(date).format('YYYY-MM-DD')
      : null;

    if (isSetFormattedDate) {
      setValue(formattedDate);
    } else {
      setValue(setValueDate);
    }
    setTouched(true);
    setError(null);
    setIsDatePickerOpen(false);
    customOnChange?.(formattedDate);
  };

  const isError = (touched || formik?.submitCount > 0) && error && !value;

  const parsedDateForDatePicker =
    isSetFormattedDate && dateFormat?.label === 'DD/MM/YYYY'
      ? convertDateFormatForDatePicker(value)
      : value;

  const triggerElement = (
    <Input
      w="100%"
      fontSize="12px"
      placeholder={dateFormat.label || 'MM/DD/YYYY'}
      value={date || meta?.value}
      id={name}
      isInvalid={isError}
      borderRadius="md"
      _hover={{
        border: 'transparent',
      }}
      _focus={{
        outline: 'none',
      }}
      onClick={() => setIsDatePickerOpen(true)}
      onFocus={(e) => e.preventDefault()}
      {...inputStyles}
    />
  );

  const newTriggerElement = (
    <Box>
      <KInput
        w="100%"
        fontSize="14px"
        placeholder={dateFormat.label || 'MM/DD/YYYY'}
        value={hasFieldValue ? value : date || meta?.value}
        id={name}
        isInvalid={isError}
        borderRadius="md"
        _hover={{
          border: 'transparent',
        }}
        _focus={{
          outline: 'none',
        }}
        onClick={() => setIsDatePickerOpen(true)}
        onFocus={(e) => e.preventDefault()}
        {...inputStyles}
        {...inputProps}
      />
    </Box>
  );

  const renderTriggerElement =
    styleVersion === 'v1' ? triggerElement : newTriggerElement;

  const popoverContent = isDatePickerOpen && (
    <DayPicker
      mode="single"
      className="schedule-date-picker filter-datepicker"
      numberOfMonths={1}
      selected={new Date(parsedDateForDatePicker)}
      defaultMonth={value ? new Date(parsedDateForDatePicker) : new Date()}
      onSelect={(date) => {
        setFieldProps(date);
      }}
      disabled={
        isCustomize && customDisableDateValue
          ? [customDisableDateValue]
          : isCustomize
          ? []
          : [{ after: new Date() }]
      }
      {...dayPickerProps}
    />
  );

  return (
    <Flex flexDir="column" w="100%">
      <PopoverWrapper
        containerRef={containerRef}
        trigger={renderTriggerElement}
        content={popoverContent}
        isOpen={isDatePickerOpen}
        onClose={() => setIsDatePickerOpen(false)}
      />
    </Flex>
  );
};
